import React from 'react';
import SearchIcon from './SearchIcon';

/**
 * Reusable search bar.
 * @param {string} placeholder
 * @param {string} ariaLabel
 */
const SearchBar = ({ placeholder = 'Cerca...', ariaLabel = 'Cerca' }) => {
  return (
    <div className="search-bar">
      <SearchIcon className="search-bar__icon" />
      <input
        type="text"
        className="search-bar__input"
        placeholder={placeholder}
        aria-label={ariaLabel}
      />
    </div>
  );
};

export default SearchBar;
